import type { MouseEventHandler } from 'react';
import styled, { css } from 'styled-components';

import { Flex } from '@/components/Flex';

export const Wrapper = styled(Flex)<{
  onClick?: MouseEventHandler;
}>`
  text-align: center;
  flex-direction: column;

  ${({ onClick }) =>
    onClick &&
    css`
      &:hover {
        cursor: pointer;
      }
    `}
`;

export type Variant = 'grey' | 'white';

export const IconWrapper = styled(Flex)<{ variant: Variant }>`
  align-items: center;
  justify-content: center;
  align-self: center;
  transition: color 200ms ease-in-out;
  width: 70px;
  background: ${({ theme }) => theme.colors.defaultAdd6};
  height: 70px;
  border-radius: 70px;
  margin: 10px 0;
  border: 1px solid ${({ theme }) => theme.colors.tertiaryGrey};

  ${({ theme, variant }) =>
    variant === 'white' &&
    css`
      background: ${theme.colors.white};
    `}

  &:hover {
    color: ${({ theme }) => theme.colors.primary};
  }
`;
